export default {
  collectionType: {
    activity: '003',
    course: '007',
    study: '007',
    news: '001',
    policy: '012',
    goods: '005',

  }
}
